import React, { useEffect, useState } from "react";
import { FiCheckCircle, FiPlus } from "react-icons/fi";
import { CustomTable, Modal } from "src/component";
import { FiEdit2 } from "react-icons/fi";
import { MdOutlineCancel } from "react-icons/md";
import { CreateAppliances } from "src/Modal";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getAllAppliances, updateAppliance } from "src/services/api";
import { renderAlert, renderConfirmDialogue } from "src/utils/functions";
import { useSearchParams } from "react-router-dom";

const Appliances = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [applianceData, setApplianceData] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page")) || 1;
  const perPage = parseInt(searchParams.get("per_page")) || 10;

  const { data, refetch } = useQuery({
    queryKey: ["appliance", page, perPage],
    queryFn: () => getAllAppliances({ page, limit: perPage }),
    suspense: true,
  });

  useEffect(() => {
    if (!searchParams.has("page")) searchParams.set("page", 1);
    if (!searchParams.has("per_page")) searchParams.set("per_page", 10);
    setSearchParams(searchParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { mutate, isLoading } = useMutation(updateAppliance, {
    onSuccess: (res) => {
      renderAlert({
        title: "Success",
        msg: res?.msg,
        type: "success",
      });
      refetch();
    },
  });

  const columns = [
    {
      name: "S/N",
      cell: (_, i) => i + 1,
      width: "5%",
    },
    {
      name: "Name",
      cell: (row) => <div className="capitalize">{row?.name}</div>,
    },
    {
      name: "Minimum Rating",
      cell: (row) => row?.minRating + " Watt(s)",
      width: "15%",
    },
    {
      name: "Maximum Rating",
      cell: (row) => row?.maxRating + " Watt(s)",
      width: "15%",
    },
    {
      name: "Status",
      cell: (row) => <div className="capitalize">{row?.status}</div>,
      width: "15%",
    },

    {
      name: "Action",
      cell: (row) => (
        <div className="flex items-center justify-start gap-[2rem]">
          <div
            className="flex items-center justify-start my-1 gap-[.5rem] rounded-[1.2rem] text-[1.4rem]  font-normal cursor-pointer hover:text-defaultPrimary"
            onClick={() => {
              setModalOpen(true);
              setApplianceData(row);
            }}
          >
            <FiEdit2 size="1.6rem" />
            Update
          </div>
          {row?.status === "enabled" ? (
            <div
              className="flex items-center justify-start my-1 gap-[.5rem]  rounded-[1.2rem] text-[1.4rem] font-normal cursor-pointer hover:text-defaultPrimary"
              onClick={() => {
                renderConfirmDialogue(
                  "Are you sure?",
                  "Are you sure you want to disable this appliance?",
                  "Yes, disabled it!"
                ).then((confirmed) => {
                  if (confirmed) {
                    mutate({
                      id: row?.id,
                      name: row?.name,
                      minRating: row?.minRating,
                      maxRating: row?.maxRating,
                      status: "disabled",
                    });
                  }
                });
              }}
            >
              <MdOutlineCancel size="2rem" />
              Disabled
            </div>
          ) : (
            <div
              className="flex items-center justify-start my-1 gap-[.5rem]  rounded-[1.2rem] text-[1.4rem] font-normal cursor-pointer hover:text-defaultPrimary"
              onClick={() => {
                renderConfirmDialogue(
                  "Are you sure?",
                  "Are you sure you want to enabled this appliance?",
                  "Yes, enabled it!"
                ).then((confirmed) => {
                  if (confirmed) {
                    mutate({
                      id: row?.id,
                      name: row?.name,
                      minRating: row?.minRating,
                      maxRating: row?.maxRating,
                      status: "enabled",
                    });
                  }
                });
              }}
            >
              <FiCheckCircle size="2rem" />
              Enabled
            </div>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="flex items-center justify-between mb-[3rem]">
        <p className="text-[2.5rem] font-medium text-defaultPrimary">
          Appliances
        </p>

        <div className="flex justify-center items-center gap-[3rem]">
          <button
            className="bg-lightPrimary py-[1rem] px-[1.8rem] text-defaultPrimary text-[1.5rem] rounded-lg flex items-center gap-2"
            onClick={() => {
              setModalOpen(true);
              setApplianceData("");
            }}
          >
            <FiPlus size={15} />
            Create Appliances
          </button>
        </div>
      </div>

      <div>
        <CustomTable
          columns={columns}
          data={data?.data?.records}
          paginationTotalRows={data?.data?.pagination?.total}
          paginationPerPage={perPage}
          progressPending={isLoading}
          paginationDefaultPage={page}
        />
      </div>

      <Modal
        isOpen={modalOpen}
        setIsOpen={setModalOpen}
        title={applianceData ? "Update Appliance" : "Create Appliance"}
      >
        <CreateAppliances
          editData={applianceData}
          setModalOpen={setModalOpen}
          refetch={refetch}
        />
      </Modal>
    </>
  );
};

export default Appliances;
